import { isDnf } from "model/Match/DriverTime";
import { getRosterDriverIds, getRosterId, Roster } from "model/Roster/Roster";
import { RoundTime } from "model/Match/Track/RoundTime";
import { RosterScope } from "model/Roster/RosterScope";

export type WorldTourScoring = {
  [key: string]: number[];
};

export const getWorldTourRoundPoints = (
  scoring: WorldTourScoring,
  times: RoundTime[],
  rosters: Roster[],
  rosterScope: RosterScope
) => {
  const rosterPositions: { [rosterId: string]: number[] } = {};
  for (var i = 0; i < rosters.length; i++) {
    const roster = rosters[i];
    const rosterId = getRosterId(roster);
    if (!rosterId) {
      continue;
    }

    const rosterDriverIds = getRosterDriverIds(roster, rosterScope) ?? [];
    const rosterTimes = times.filter((t) =>
      rosterDriverIds.includes(t.driverId)
    );
    const nonDnfPositions = rosterTimes
      .filter((t) => !isDnf(t))
      .map((t) => t.position);
    rosterPositions[rosterId] = nonDnfPositions.sort((a, b) => a - b);
  }

  const sortedRosterIds = getSortedRosterIdsByBestPosition(rosterPositions);
  const scoringKey = getWorldTourScoringKey(
    sortedRosterIds.map((rosterId) => rosterPositions[rosterId])
  );

  const points = scoring[scoringKey];
  const rosterPoints: { [id: string]: number } = {};
  sortedRosterIds.forEach(
    (rosterId, idx) => (rosterPoints[rosterId] = points?.at(idx) ?? 0)
  );

  return rosterPoints;
};

const getWorldTourScoringKey = (sortedPositions: number[][]) => {
  return sortedPositions.map((p) => p.join(",")).join("-");
};

const getSortedRosterIdsByBestPosition = (rosterPositions: {
  [id: string]: number[];
}) => {
  return Object.keys(rosterPositions).sort((a, b) => {
    const aBestPos = rosterPositions[a].at(0);
    const bBestPos = rosterPositions[b].at(0);
    if (!aBestPos && !bBestPos) {
      return 0;
    }

    if (!aBestPos) {
      return 1;
    }

    if (!bBestPos) {
      return -1;
    }

    return aBestPos < bBestPos ? -1 : 1;
  });
};
